<template>
<div id="oidclogin">
  OIDC 登录中...
</div>
</template>

<script>
/**
 * OIDC 跳转登录专用，避免重定向问题
 * 登录页面从 OIDC Server 跳转过来之后，先来到这个页面，写入 session storage
 */
import cache from '@/core/cache'
import auth from '@/core/auth'

export default {
  name: 'oidclogin',
  created () {
    // 检测是否有 Oidc 登录流程
    console.log('oidcLoginObj in query string: %o', this.$route.query)
    const oidcLoginObj = auth.checkOidcAuth({ loginObj: this.$route.query })
    if (oidcLoginObj) {
      console.log('oidcLoginObj in query string: %o', oidcLoginObj)
      if (oidcLoginObj.error) {
        // 登录失败需要登出，取消所有缓存
        auth.logout()
        alert(decodeURIComponent(oidcLoginObj.error))
      } else {
        cache.setValue('oidcLogin', oidcLoginObj)
        // 清空 search 字符串避免再次调用
        // 跳转到首页。首页会检测 oidcLogin 这个缓存的数据来登录。
        // 为使用 window.location.search = '' 会引发跳转。还不如直接使用 href 强行跳转
        window.location.href = window.location.pathname
      }
    }
  }
}
</script>
